import { getClientHost } from '../../lib/constants/constants';

export const isLocalhost = (host = window.location.host) => {
  const hostname = host.split(':')[0];
  return (
    hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === '127.0.0.1' || hostname === '[::1]'
  );
};

export const prettyDateTime = (time) => {
  let date = new Date(time);
  return (
    date.toLocaleDateString('en', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
    }) +
    ' at ' +
    date.toLocaleTimeString('en', { hour: '2-digit', minute: '2-digit' }).replace(/^0(?:0:0?)?/, '')
  );
};
export const prettyDate = (time) => new Date(time).toLocaleDateString('en', {});

export const prettyDateLong = (time) =>
  new Date(time).toLocaleDateString('en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
export const ageFromDate = (birthDateString) => {
  const birthDate = new Date(birthDateString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return 'Age: ' + age;
};
export const getUrlParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};
export const prettyTime = (time) => new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const prettyHour = (time) =>
  new Date(time).toLocaleTimeString('en', { hour: '2-digit', minute: '2-digit' }).replace(/^0(?:0:0?)?/, '');

export const prettyPhone = (number) =>
  number.substr(2).replace(/(\d{1,2})(\d{1})?(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3, p4) {
    let output = '';
    if (p1) output = `${p1}`;
    if (p2) output += `${p2}-`;
    if (p3) output += `${p3}-`;
    if (p4) output += `${p4}`;
    return output;
  });

export const toCapitalize = (sentence) =>
  sentence.length ? sentence.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()) : '';

export const toCapitalizeFromUnderScore = (name) =>
  name
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
export const toUnderScoreSlug = (name) =>
  name
    .split(' ')
    .map((word) => word.toLowerCase())
    .join('_');
export const getInitials = (fullName) => {
  return fullName
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase())
    .join('');
};

export const groupBy = (list, key) => {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const keyBy = (array, key) => (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

export const keyByCollection = (collection, key) => {
  const c = collection || {};
  return c.isArray() ? keyBy(c, key) : Object.values(keyBy(c, key));
};
export const compactArray = (array) => array.filter(Boolean);

export const getCookie = (n) => {
  let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
  return a ? a[1] : '';
};
export const setCookie = (name, value, days = 365) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};
export const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const roundHalf = (n) => {
  return (Math.round(n * 2) / 2).toFixed(1);
};

export const cmToInFt = (cm, inches = Math.round(cm / 2.54)) => {
  return Math.floor(inches / 12) + "'" + (inches % 12) + '"';
};

export const kgToLbs = (kg) => {
  return Math.floor(kg * 2.20462262185);
};

/**
 * Truncates a string to a maximum length. The maxLenth set is arbitrary here.
 *
 * @param {string} string - The string to truncate.
 * @param {number} maxLength - The maximum length of the string.
 * @returns {string} The truncated string.
 */
export const truncate = (string, maxLength = 70) => {
  if (!string) return string;
  return string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;
};
/**
 * Helper function to check if text might be truncated
 *
 * @param {string} text - The text to check.
 * @param {number} length - The length of the text.
 * @returns {boolean} Whether the text might be truncated.
 */
export const isTruncated = (text, length) => {
  if (!text) return false;
  return text.length > length;
};
export const readFileAsString = (file) => {
  var request = new XMLHttpRequest();
  request.open('GET', file, false);
  request.send(null);
  var returnValue = request.responseText;
  return returnValue;
};
export const isSameDay = (date1, date2) => {
  const date1Date = new Date(date1);
  const date2Date = new Date(date2);
  return (
    date1Date.getFullYear() === date2Date.getFullYear() &&
    date1Date.getMonth() === date2Date.getMonth() &&
    date1Date.getDate() === date2Date.getDate()
  );
};

export const formatAddress = (location) => {
  const { address, address_2, city, state, zip, country } = location;
  return `${address}${address_2 ? `, ${address_2}` : ''}, ${city}, ${state}, ${country} ${zip}`;
};

export const handleTakeAssessment = () => {
  const assessmentUrl = `${getClientHost()}/assessment/start`;
  window.open(assessmentUrl, '_blank');
};

export const getWorkflowToken = (workflowShareUrl) => {
  const workflowToken = workflowShareUrl ? workflowShareUrl.split('#/s/')[1] : null;
  return workflowToken;
};
